import MenuProfile from "../MenuProfile";
import "./index.css";

interface FunctionHeaderProps {
  title?: string;
  subtitle?: string;
}

const FunctionHeader = ({ title, subtitle }: FunctionHeaderProps) => {
  return (
    <header className="">
      <div className="page-header cols">
        <div className="col-8">
          <div className="title ">{title}</div>
          <div className="subtitle ">{subtitle}</div>
        </div>
        <div className="profile col-2">
          <MenuProfile />
        </div>
      </div>
    </header>
  );
};

export default FunctionHeader;
